import React, { useEffect, useState } from "react";

import {
    setDescription,
    setTitle,
    populateWorkWithUsData,
    saveWorkWithUsLocalSession,
    getWorkWithUsFromLocalSession
} from "../../utils";

import Styles from "./workWithUs.module.css";
import "./workWithUs.css"
import { renderBullets, renderButton } from "../../helpers";
import { Loader } from "../../components/loader/loader";
import { Error } from "../../components/error/error";
import { Hero } from "../../components/hero/heroParallax"
import heroImage from "../../assets/images/work-with-us/work-with-us-hero2.jpg";
import { Reveal } from "../../components/animations/reveal/reveal";
import { FadeIn } from "../../components/animations/fadeIn/fadeIn";
//import { SlideRight } from "../../components/animations/slideRight/slideRight";
//import { SlideLeft } from "../../components/animations/slideLeft/slideLeft";

export const WorkWithUs = () => {
    const [displayItems, setDisplayItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setTitle("Marketing Manchester | Work with us");
        setDescription("Whether your business functions within the visitor economy, inward investment, the property sector, or somewhere in between, Marketing Manchester has the right opportunities for you");
    }, []);

    const fetchWork = async () => {
        try {
            setIsLoading(true);
            let data = getWorkWithUsFromLocalSession();
            if (!data) {
                data = await populateWorkWithUsData();
                saveWorkWithUsLocalSession(data);
            }
            setDisplayItems(data);
        } catch (error) {
            setError({ message: "Uh oh, looks like something went wrong" });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchWork();
    }, []);
    
    return (
        <>
            <Hero
                image={heroImage}
                height="75vh"
                title="Work with us"
            />
            <div className={`${Styles.pageContainer}`}>
                {
                    isLoading ? <Loader page="Work with us" /> :
                        error ? <Error error={error} id="dashboard-error" page="Workwithus" /> :
                        displayItems.slice(0, 10).map((work, idx) => (

                            <div className={`sectionContainer${idx + 1} 
                                ${idx === 1 ? Styles.yellowBg_10 : ''} ${idx === 2 ? Styles.ecoGreenBg_10 : ''} ${idx === 3 ? '' : ''} ${idx === 4 ? Styles.ltRedBg : ''} ${idx === 5 ? Styles.creamBg : ''} ${idx === 6 ? Styles.ltBlueBg : ''} ${idx === 7 ? Styles.ltGreyBg : ''} ${idx === 8 ? Styles.creamBg : ''} ${idx === 9 ? Styles.whiteBg : ''}`}
                                key={work.id}>
                                {idx % 2 === 0 || idx === 0 ?
                                    <div className={`Section${idx + 1}`} >
                                        <div>
                                            <Reveal>
                                                <h1>{work.title}</h1>
                                            </Reveal>
                                            <Reveal>
                                                <h3>{work.mainText}</h3>
                                            </Reveal>
                                            <Reveal>
                                                {renderBullets(work)}
                                            </Reveal>
                                            <Reveal>
                                                <p>{work.subText}</p>
                                            </Reveal>
                                            <Reveal>
                                                {renderButton(work)}
                                            </Reveal>
                                        </div>
                                        <FadeIn>
                                            <div style={{ backgroundImage: `url(data:image/png;charset=ISO-8859-1;base64,${work.bannerImage})` }} className={`image${idx + 1}`}></div>
                                        </FadeIn>
                                    </div>
                                    :
                                    <div className={`Section${idx + 1}`} >
                                        <FadeIn>
                                            <div style={{ backgroundImage: `url(data:image/png;charset=ISO-8859-1;base64,${work.bannerImage})` }} className={`image${idx + 1}`}></div>
                                        </FadeIn>
                                        <div>
                                            <Reveal>
                                                <h1>{work.title}</h1>
                                            </Reveal>
                                            <Reveal>
                                                <h3>{work.mainText}</h3>
                                            </Reveal>
                                            <Reveal>
                                                {renderBullets(work)}
                                            </Reveal>
                                            <Reveal>
                                                <p>{work.subText}</p>
                                            </Reveal>
                                            <Reveal>
                                                {renderButton(work)}
                                            </Reveal>
                                        </div>

                                    </div>
                                }
                            </div>
                        ))
                }
            </div>
        </>
    );
};